import React from 'react';
import { Typography } from '@material-ui/core';

import Spec from '../../../models/Spec';
import { SpecComments } from '../../Spec/SpecComments';

interface Props {
  spec: Spec
  onSpecChange?: (spec: Spec) => void
}

const Comments = (props: Props) => {
  const { spec } = props;
  return spec.id ? (<SpecComments specId={spec.id} />) : (<Typography>Not Available</Typography>);
};

export default Comments;